<template>
  <template
    v-for="route in routes"
    :key="route.name"
  >
    <NuxtLink
      :active-class="'active'"
      class="subtitle-1 tw-md:tw-mr-6"
      :to="route.path"
      :data-testid="route.testid"
      :class="{
        active: route.path.startsWith('/manage-jobs') && $route.path.startsWith('/manage-jobs'),
      }"
    >
      {{ route.name }}
      <span
        v-if="route.badge"
        class="badge"
      >
        {{ route.badge }}
      </span>
    </NuxtLink>
  </template>
</template>

<script setup>
const props = defineProps({
  routes: Array,
  default: [],
});
</script>

<style lang="scss" scoped>
@use '@/assets/scss/badge.scss';
@use '@/assets/scss/container.scss';

.subtitle-1 {
  @apply tw-inline-flex tw-cursor-pointer tw-items-center tw-justify-between tw-gap-1 tw-px-4 tw-text-base tw-font-regular tw-capitalize tw-text-grey-dark;

  padding-top: 23px; // Dev Note: fix this in another task
  padding-bottom: 14px;
  border-bottom: 2px solid transparent;
  transition: all 0.15s ease-in-out;
  text-decoration: none;

  &:hover {
    @apply tw-border-b-2 tw-border-secondary-base tw-text-black-670;
  }

  &.active {
    @apply tw-border-b-2 tw-border-secondary-base tw-text-secondary-base;
  }
}
</style>
